module.exports = __webpack_public_path__ + "media/images/sesgo-019146280fce6452ad63295fc3e48ef7.png";